import React from "react"
import scrollTo from "gatsby-plugin-smoothscroll"

const Splash = () => (
  <div className="splash">
    <div className="container">
      <section className="splash__content">
        <h1>More Traffic, More Calls, and More New Patients</h1>
        <p>
          Scale Your Practice with Strategic Search Engine Marketing and Lead
          Generation Campaigns
        </p>
        <div className="splash-button">
          <a
            className="scroll-to btn btn_info"
            onClick={() => scrollTo("#services")}
          >
            Learn More
          </a>
        </div>
      </section>
    </div>
  </div>
)

export default Splash
